

//demo
export default {
    nativetoken: {

        //bsc
        56: '0xC40B73d75Ffc7d01987ec172D7f9931f39e6ab8e',  //M
        97: '0x0A4dD2F74558e181C50D3efd7551ceE73A2F8f66',//'0xB91cE3a9095CD9A01Ab419081c8F63bf6d9ABe2a', //T

        //Eth
        1: '0x6428ca3826f67d71B6cAeDeFba58d6f7ad1eeF51', //M
        11155111: '0xE478d54723F0Ed1DC5026445785e94AF346d11C2', //T

        //Avax
        43114: '', //M
        43113: '0x296EFfbF5Cc1Dad8035302E54A6360C09896dc45', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    xtoken: {

        //bsc
        56: '', //M
        97: '0x0D3B32a16dab18173696b6cbB267D6fc0018D3a8', //T

        //Eth
        1: '', //M
        11155111: '', //T

        //Avax
        43114: '', //M
        43113: '', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    dividends: {

        //bsc
        56: '', //M
        97: '0x51cf7388044bB4C119941973161328aEbB52809b', //T

        //Eth
        1: '', //M
        11155111: '', //T

        //Avax
        43114: '', //M
        43113: '', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    multicall: {

        //bsc
        56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B', //M
        97: '0x232e410b1fa58fa37921ad03E5deC6a507cd5CDe', //T

        //Eth
        1: '', //M
        11155111: '0xE8039f1fbbd2531AA92f553De008510CdA2F7EB9', //T

        //Avax
        43114: '', //M
        43113: '0x279A2739dF44E9E12968909968985bAd8e5520dB', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    router: {

        //bsc
        56: '0x3d0818122a87451e7Fc03dF1718E64a18C01ebDd', //M
        97:'0x27f55fEAe924a231b5C8B5dF6e00DA5a62EF2A4d',//'0x4ac4356ab7Ef501a184B91061d651Ae4771197FF', //0x0DEb4ccCd468Ca51b56641a40570b24b61087Fb6  //T

        //Eth
        1: '', //M
        11155111: '0x866f7953220F5f0DDE2Fe97c1aFabd4b34EAC39F', //T
        

        //Avax
        43114: '', //M
        43113: '0xC4e02705F9513fB3ce120F95aB8a0d8c4F0419bf', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    factory: {

        //bsc
        56: '0xF6a699942022c1a106800972864Dd3f8C02Bc434', //M
        97: '0x5a6f59E26d42A8Dcc58153d4ebb2c5ca0668F7c2', // '0xf6DFAC0edd10Fc06D5B69B8bAE8E287850F6848f',//'0x582fDAE9a8dEfa3C59e989F25e7ADE2Dc5B29538', //T

        //Eth
        1: '', //M
        11155111: '0x16C411a33f6D5ab94a52797653B66EF2Aa4e4820', //T

        //Avax
        43114: '', //M
        43113: '0xc5c26A06FF435859d32c0D07c4418d8877b1E1dB', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    masterChef: {

        //bsc
        56: '0x1D9ef7f426E9aB25Ad46E5C99bc5267C23212930', //M
        97: '0x2733516c74f0D97120C89b427738432e3120b874',//'0x7482005B3271CfbAc64D1928E17194287f02EB6e', //T

        //Eth
        1: '', //M
        11155111: '0x28D6E06F0dD1D16F11F258F2510114416AA2d0dc', //T

        //Avax
        43114: '', //M
        43113: '0xC049F2a686BeD7a27C7f20c657FBd88446F368F5', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    SmartChefFactory: {

        //bsc
        56: '0xBe2C755404aF61d8946a850316162A9aEF30e672', //M
        97: '0x036068610C528e3a8D8726c1A7ebDFF39a82Eb12',//'0x758c2861114970b01dD1981fCc19Cb7B64cc956f', //T

        //Eth
        1: '', //M
        11155111: '0x0a1C0E2B83F1f4BaDb16fDe5C0b2D6642d19444b', //T

        //Avax
        43114: '', //M
        43113: '0x38EaA8cdEDcbF8B66914E7fb38D04a47ACA49b61', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    Lockedstacking: {

        //bsc
        56: '0xc5B68dC5e73889b8E96566FD01d2B8386436594C', //M
        97: '',//'0x758c2861114970b01dD1981fCc19Cb7B64cc956f', //T

        //Eth
        1: '0x9799a876ae2929C47E3f65CB3769D3098Ec82066', //M
        //11155111: '0xaf8593cBd1B61fc1AeEBA70d579013d81044d9C5', //1
      //  11155111: '0x6E58ee2af386d43c25613Ae4E36704d6f1D97718', //2
    //  11155111: '0x0758000c2334Bef3B26edaf089820CE658ebc2d9', //3
      // 11155111: '0x3511B24D145c40E50886B05D5E8946277cd8D771', //3

      // 11155111: '0x263bAB98Db3CF1E2382eaBd1f30116cEBa2AFC65', //3
       11155111: '0xe10c8666b3Ba79C4f1d9C7F2e695699f886bB7a7', //3




        //Avax
        43114: '', //M
        43113: '', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    poolAddress: {

        //bsc
        56: '0xea3B56818609f6b8144eCf16aE0A6738474473CA', //M
        97: '0xE632916dE60b40398E454FD350DFf22575f4493F', //T

        //Eth
        1: '', //M
        11155111: '0x8f6b867E1A5b591c4Ae029f1Ce5B17B616b65ff1', //T

        //Avax
        43114: '', //M
        43113: '', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    },
    poolLockAddress: {

        //bsc
        56: '', //M
        97: '', //T

        //Eth
        1: '', //M
        11155111: '', //T

        //Avax
        43114: '', //M
        43113: '', //T

        //Arbitrum
        42161: '', //M
        421614: '', //T

        //zkSync
        324: '', //M
        280: '', //T

    }
}